import { render, staticRenderFns } from "./ShippingMethod.vue?vue&type=template&id=5b7c4d80&scoped=true"
import script from "./ShippingMethod.vue?vue&type=script&lang=js"
export * from "./ShippingMethod.vue?vue&type=script&lang=js"
import style0 from "./ShippingMethod.vue?vue&type=style&index=0&id=5b7c4d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7c4d80",
  null
  
)

export default component.exports